import { Container } from "@mui/material";
import Banner from "components/templates/Banner";
import KioskHomeVideoForm from "./KioskHomeVideoForm";
import ImageService from "services/image.service";
import DynamicService from "services/dynamics.service";
import ToasterService from "utils/toaster.util";
import { useAppSelector } from "redux/hooks";
import CircleLoader from "components/atoms/CircleLoader";


export default function KioskHomeVideo() {
    const loading = useAppSelector((state) => state.dynamics.loading)

    const handleSubmit = async (values: any) => {
        try {
            const { title, video } = values;
            const formData = new FormData();
            if (title) formData.append("title", title);

            if (video && (video.name || video.blob)) {
                const fileLike = video.name ? await ImageService.getImageFileFromBlob(video) : video.blob;
                const type = (fileLike as File)?.type || "";
                const name = (fileLike as File)?.name || video.name || "";
                const allowed = ["video/mp4", "video/webm", "video/mov"];
                const allowedExt = [".mp4", ".webm", ".mov"];
                const hasAllowedType = allowed.includes(type);
                const hasAllowedExt = allowedExt.some((ext) => name?.toLowerCase().endsWith(ext));
                if (!hasAllowedType && !hasAllowedExt) {
                    ToasterService.showError("Only MP4, WebM or MOV videos are allowed");
                    return;
                }
                formData.append("video", fileLike as Blob, name || `video.${hasAllowedType ? type.split("/")[1] : "mp4"}`);
            }

            await DynamicService.uploadKioskHomeVideo(formData);
        } catch (e) {
            ToasterService.showError("Failed to upload video");
        }
    };

    return (
        <div>
        {loading && <CircleLoader />}
            <Container maxWidth="lg">
                <Banner heading="Kiosk Home Video" />
                <KioskHomeVideoForm onSubmit={handleSubmit} />
            </Container>
        </div>
    );
}


